import axios from "./_axios";
import { API } from "./apiEndPoints";

/**
 * Admin onboarding-step authoring API (ER-11474 / MDP-600).
 *
 * Thin wrappers over the v2 ``onboarding-step`` viewset (companion backend
 * ticket ER-11471). List reads are module-scoped via a ``module`` query param;
 * mutations mirror the Rule 3 status-transition graph exactly (activate /
 * retire / reactivate) plus draft-only delete and drag-and-drop reorder.
 */

/**
 * List onboarding steps, optionally scoped to a module.
 *
 * @param {{ module?: string }} [params] Module filter (YOUR_STUFF | ORGANIZATION | FAIR_PAY).
 */
export const getOnboardingSteps = (params = {}) =>
  axios()({
    method: "get",
    url: API.ONBOARDING_STEP,
    params,
  });

/**
 * Create a DRAFT step appended at the bottom of a module's sequence.
 *
 * @param {{ module: string, name?: string }} data Module + add-dialog step name.
 */
export const createOnboardingStep = (data) =>
  axios()({
    method: "post",
    url: API.ONBOARDING_STEP,
    data,
  });

/**
 * Patch editable step fields (guide_key, tip_tap_content, text, sequence).
 *
 * @param {number} id Step id.
 * @param {object} data Partial step fields.
 */
export const updateOnboardingStep = (id, data) =>
  axios()({
    method: "patch",
    url: `${API.ONBOARDING_STEP}${id}/`,
    data,
  });

/**
 * Delete a DRAFT step (the only status deletion is allowed from).
 *
 * @param {number} id Step id.
 */
export const deleteOnboardingStep = (id) =>
  axios()({
    method: "delete",
    url: `${API.ONBOARDING_STEP}${id}/`,
  });

/**
 * DRAFT -> ACTIVE transition.
 *
 * @param {number} id Step id.
 */
export const activateOnboardingStep = (id) =>
  axios()({
    method: "post",
    url: `${API.ONBOARDING_STEP}${id}/activate/`,
  });

/**
 * ACTIVE -> RETIRED transition.
 *
 * @param {number} id Step id.
 */
export const retireOnboardingStep = (id) =>
  axios()({
    method: "post",
    url: `${API.ONBOARDING_STEP}${id}/retire/`,
  });

/**
 * RETIRED -> ACTIVE transition.
 *
 * @param {number} id Step id.
 */
export const reactivateOnboardingStep = (id) =>
  axios()({
    method: "post",
    url: `${API.ONBOARDING_STEP}${id}/reactivate/`,
  });

/**
 * Renumber a whole module from an explicit step-id order (drag & drop).
 *
 * @param {{ module: string, ordered_step_ids: number[] }} data Reorder payload.
 */
export const reorderOnboardingSteps = (data) =>
  axios()({
    method: "post",
    url: `${API.ONBOARDING_STEP}reorder/`,
    data,
  });
